import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_SUPERVISE_API

// 上传凭证
export function getSuperviseUploadPolicy() {
  return request(
    {
      url: baseUrl + '/cloud-purchase/attachments/upload-policy',
      method: 'post'
    },
    false
  )
}

// 查询附件
export function getSuperviseFileListApi(params) {
  return request(
    {
      url: baseUrl + `/cloud-purchase/attachments`,
      method: 'get',
      params
    },
    false
  )
}

// 分页查询风险列表 （督办）
export function getSuperviseRiskListApi(params) {
  return request({
    url: baseUrl + `/cloud-purchase/risks/page`,
    method: 'get',
    params
  })
}

// 查询风险详情（督办）
export function getSuperviseRiskDetailApi(riskId) {
  return request({
    url: `${baseUrl}/cloud-purchase/risks/${riskId}`,
    method: 'get'
  })
}

// 接受风险（督办）
export function receiveSuperviseRiskApi(riskId) {
  return request({
    url: `${baseUrl}/cloud-purchase/risks/${riskId}/receive`,
    method: 'post'
  })
}

// 处理风险（督办）
export function handleSuperviseRiskApi(riskId, data) {
  return request({
    url: `${baseUrl}/cloud-purchase/risks/${riskId}/handle`,
    method: 'post',
    data
  })
}
